import React from 'react';
import ManageAgreements from 'us.collection/components/ManageAgreements/ManageAgreements';
import { useNavigate, useLocation } from "react-router-dom";
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_Agreements {
    caseNo: number;
}

const Cnt_Agreements: React.FC<ICnt_Agreements> = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as INavigationData;

    const onMinimize = () => {
        navigate(`/case/${props.caseNo}` , { state });
    }

    return (
        <>
            <ManageAgreements onMinimize={() => onMinimize()} {...props} />
        </>
    );
};

export default Cnt_Agreements
